import { DownloadPDF } from '@/_containers';

import { useGetPickTicketsPDFMutation } from '../apis';

export function DownloadPickTicketsPDF({ id }: { id: string }) {
  const { mutateAsync } = useGetPickTicketsPDFMutation(id);

  return <DownloadPDF mutateFunction={mutateAsync} />;
}
